require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./careers-software-solution-architect-uk.json") })
        }
      }, "path---careers-software-solution-architect-uk");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---careers-software-solution-architect-uk!./.cache/json/careers-software-solution-architect-uk.json
// module id = 879
// module chunks = 231608221292675